import { componentsThemeMap } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { useCanonicalUrl } from '../../providers/CanonicalUrlProvider.js';
import { useGlobalMicrocopy } from '../../providers/MicrocopyProvider.js';
import { CTAButtons } from '../../ui/CTAButtons.js';
import '../../ui/Div/index.js';
import '../../ui/Link/index.js';
import '../../ui/RichText/index.js';
import '../../ui/ShareLinks/index.js';
import { Text } from '../../ui/Text.js';
import { editorialHeroFormatOptions } from './editorialHeroFormatOptions.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { RichText } from '../../ui/RichText/RichText.js';
import { Link } from '../../ui/Link/Link.js';
import { ShareLinks } from '../../ui/ShareLinks/ShareLinks.js';
function HeroEditorialContent({
  headline,
  subhead,
  ctaButtonLabel,
  ctaButtonUrl,
  secondaryButtonLabel,
  secondaryButtonUrl,
  author,
  datePublished,
  categoryTagLabel,
  categoryTagUrl,
  readTime,
  style,
  showSocialSharingLinks
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    background = _componentsThemeMap$s.background,
    primary = _componentsThemeMap$s.primary;
  const canonicalUrl = useCanonicalUrl();
  const microcopies = useGlobalMicrocopy();
  return /*#__PURE__*/jsxs(Div, {
    flexGrow: 1,
    spacingTop: 8,
    overflow: "hidden",
    flexDirection: "column",
    justifyContent: "center",
    children: [/*#__PURE__*/jsx(Text, {
      as: "h1",
      variant: "display2",
      color: foreground,
      children: headline
    }), subhead && /*#__PURE__*/jsx(Div, {
      spacingTop: {
        sm: 1,
        md: 2,
        lg: 3
      },
      flexDirection: "column",
      children: /*#__PURE__*/jsx(RichText, {
        richTextOptions: editorialHeroFormatOptions,
        content: subhead,
        color: foregroundSecondary
      })
    }), /*#__PURE__*/jsx(CTAButtons, {
      ctaButtonLabel: ctaButtonLabel,
      ctaButtonUrl: ctaButtonUrl,
      secondaryButtonLabel: secondaryButtonLabel,
      secondaryButtonUrl: secondaryButtonUrl,
      contentBackground: background
    }), /*#__PURE__*/jsxs(Div, {
      spacingTop: 2,
      rowGap: 2,
      columnGap: {
        sm: 2,
        md: 4
      },
      flexDirection: {
        sm: 'column',
        md: 'row'
      },
      alignItems: {
        sm: 'start',
        md: 'baseline'
      },
      flexWrap: "wrap",
      children: [/*#__PURE__*/jsxs(Text, {
        variant: "legal",
        as: "p",
        color: foregroundSecondary,
        children: [microcopies.global.by, " ", author || microcopies.global.author]
      }), /*#__PURE__*/jsxs(Div, {
        flexWrap: "wrap",
        alignItems: "baseline",
        children: [categoryTagLabel && (categoryTagUrl ? /*#__PURE__*/jsx(Link, {
          href: categoryTagUrl || '',
          "data-qa": ANALYTICS_KEY.Category,
          children: /*#__PURE__*/jsx(Text, {
            variant: "legal",
            css: {
              textDecoration: 'underline'
            },
            as: "p",
            color: primary,
            children: categoryTagLabel
          })
        }) : /*#__PURE__*/jsx(Text, {
          variant: "legal",
          as: "p",
          color: foreground,
          children: categoryTagLabel
        })), /*#__PURE__*/jsxs(Text, {
          variant: "legal",
          as: "p",
          color: foregroundSecondary,
          children: [categoryTagLabel && (datePublished || readTime) && ', ', datePublished]
        }), readTime && /*#__PURE__*/jsxs(Text, {
          variant: "legal",
          as: "p",
          color: foregroundSecondary,
          children: [(categoryTagLabel || datePublished) && ', ', readTime, " ", microcopies.global.readTime]
        })]
      }), showSocialSharingLinks && canonicalUrl && /*#__PURE__*/jsx(Div, {
        display: {
          sm: 'flex',
          md: 'none'
        },
        children: /*#__PURE__*/jsx(ShareLinks, {
          canonicalUrl: canonicalUrl
        })
      })]
    })]
  });
}
export { HeroEditorialContent };
//# sourceMappingURL=HeroEditorialContent.js.map
